import {
  ISelfReferralTrackingState,
  loadSelfReferralTrackingFromSession,
  persistSelfReferralTrackingToSession,
} from './SelfReferralTrackingSlice';
import type { RootState } from './store';

export const getSelfReferralTrackingPreloadedState = (): {
  selfReferralTracking: ISelfReferralTrackingState;
} => ({
  selfReferralTracking: loadSelfReferralTrackingFromSession(),
});

export const subscribeSelfReferralTrackingPersistence = (store: {
  getState: () => RootState;
  subscribe: (listener: () => void) => () => void;
}): (() => void) =>
  store.subscribe(() => {
    const { selfReferralTracking } = store.getState();
    persistSelfReferralTrackingToSession(selfReferralTracking);
  });
